module.exports = __webpack_public_path__ + "img/portfolio_9.db538e1e.jpg";